import React from 'react'
import { Link } from '@ally/metronome-ui'

import { Badge } from '../Badge'
import { BROWSER_SCHEMA as txt } from '../BadgeContent'
import { useHostCustomer } from '../../../../hooks/useHostCustomer'
import { isAllyPreferred, parseUserAgent } from '../utils/preferredBrowser'

function PreferredBrowserBadge(): JSX.Element {
  const { hostLoading } = useHostCustomer()
  const { browser, browserVersion } = parseUserAgent(window.navigator.userAgent)
  const type = isAllyPreferred(browser ?? '', browserVersion)
    ? 'SUCCESS'
    : 'FAILURE'

  return (
    <Badge
      status={hostLoading}
      icon={txt.icon[type]}
      heading={txt.heading[type]}
      desc={
        type === 'SUCCESS' ? (
          txt.desc.SUCCESS
        ) : (
          <>
            <Link
              to="https://www.ally.com/go/learn/browser-support/"
              text="Update your browser"
              target="_blank"
              withAllyTM="levelUp-updateYourBrowser"
            />{' '}
            for a security boost.
          </>
        )
      }
    />
  )
}

export { PreferredBrowserBadge }
